import BasketIcon from "@svg/header/buy";
import { toFarsiNumber } from "@utils/digits";
import Link from "next/link";
import { FC } from "react";

interface Props {
  cartHref: string;
  isLoggedIn?: boolean;
  cartCount: number;
}
const InstructureIconHeader: FC<Props> = ({
  cartCount,
  cartHref,
  isLoggedIn,
}) => {
  return (
    <Link
      href={cartHref}
      prefetch={false}
      aria-label={isLoggedIn ? "Checkout" : "Cart"}
    >
      <div className="relative">
        <BasketIcon className="h-5 w-5" />

        {cartCount > 0 && (
          <span className="body-xxsm absolute -right-1.5 -bottom-px flex h-4 w-3 items-center justify-center rounded-full border border-white bg-fds-brand px-2 pt-0.5 text-center text-white">
            {toFarsiNumber(String(cartCount))}
          </span>
        )}
      </div>
    </Link>
  );
};

export default InstructureIconHeader;
